module.exports = __webpack_public_path__ + "9a2cf342c786d1e0aef9aec7148b6a12.svg";